import script from "./DoctorPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoctorPage.vue?vue&type=script&setup=true&lang=ts"

import "./DoctorPage.vue?vue&type=style&index=0&id=f9c02678&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9c02678"]])

export default __exports__